import { Card, Statistic, Typography } from "antd";
import type { ReactNode } from "react";
import { DASHBOARD_RANGLARI, type DashboardRang } from "./palette";

const { Text } = Typography;

/**
 * Ikonka badge foni — tema rangining 12% xiralashtirilgani. `DASHBOARD_RANGLARI`
 * dan HISOBLANADI, ikkinchi rang jadvali YOZILMAYDI — aks holda ikkalasi
 * bir-biridan ajralib ketishi mumkin edi (palitraning o'zidagi ogohlantirish).
 */
function badgeFoni(hex: string): string {
	const son = Number.parseInt(hex.slice(1), 16);
	const r = (son >> 16) & 255;
	const g = (son >> 8) & 255;
	const b = son & 255;

	return `rgba(${r}, ${g}, ${b}, 0.12)`;
}

/**
 * Tema `colorError` (`#d03b3b`) ning rgb serializatsiyasi —
 * `Statistic` ning `styles.content` iga beriladi.
 *
 * ⚠️⚠️ **Avval AntD `red-6` (`rgb(207, 19, 34)`) edi va bu TEMA
 * QIZILIDAN BOSHQA rang.** Ikkalasi yonma-yon turganda (plitka qiymati
 * AntD qizili, `SplitBar`/`BarList` esa `#d03b3b`) panel ikki xil
 * qizil ko'rsatardi.
 *
 * ⚠️ Token emas, ANIQ qiymat: test rangni inline `style` dan o'qiydi va
 * CSS o'zgaruvchisi u yerda hal bo'lmagan holda kelardi.
 *
 * ⚠️ Hex EMAS, `rgb()` SATRI: happy-dom hex'ni `rgb()` ga
 * AYLANTIRMAYDI (`LatenessHistogram.test.tsx` da o'lchangan), ya'ni
 * `#d03b3b` yozilsa `style.color` aynan `#d03b3b` qaytarardi.
 */
export const XAVF_RANGI = "rgb(208, 59, 59)";

export interface StatCardProps {
	title: string;
	/** `undefined` — yuklanish; kartada baribir `0` ko'rsatiladi. */
	value: number | undefined;
	icon?: ReactNode;
	loading?: boolean;
	/** Karta ostidagi ikkinchi darajali izoh. */
	hint?: string;
	/**
	 * ⚠️ Ogohlantiruvchi sanoq (fake location, xavfli xodim) qizil
	 * rangda, lekin FAQAT qiymat noldan katta bo'lganda — doimo qizil
	 * karta «hammasi yomon» degan yolg'on taassurot berardi.
	 */
	warning?: boolean;
	/** Karta havola ichida bo'lsa — kursorni va hover'ni yoqadi. */
	clickable?: boolean;
	/**
	 * Ikonka badge rangi — diagrammalar bilan BITTA palitradan
	 * (`DASHBOARD_RANGLARI`), tezroq skanerlash uchun (dizayn kanvasi,
	 * «Yangi taklif» artboardi). Chaqiruvchi hisoblaydi — ogohlantiruvchi
	 * kartalarda faqat qiymat noldan katta bo'lganda `kelmagan` (qizil)
	 * beriladi, aks holda `neytral`; `StatCard` buni O'ZI HISOBLAMAYDI.
	 *
	 * ⚠️ IXTIYORIY — berilmasa ikonka rangsiz (eski ko'rinish).
	 */
	tone?: DashboardRang;
}

/**
 * Dashboard sanoq kartasi.
 *
 * ⚠️ **Router IMPORT QILINMAYDI.** Havola sahifada, kartaning
 * TASHQARISIDA quriladi (`<Link><StatCard/></Link>`), chunki havola
 * `reports:read` ruxsatiga bog'liq va ruxsatsiz foydalanuvchida umuman
 * yaratilmasligi kerak.
 */
export function StatCard({
	title,
	value,
	icon,
	loading = false,
	hint,
	warning = false,
	clickable = false,
	tone,
}: StatCardProps) {
	// ⚠️ `value ?? 0` — antd `undefined` ni «-» qilib ko'rsatardi va
	// «bugun hech kim kechikmagan» yuklanish holatidan ajralmasdi.
	const sanoq = value ?? 0;
	const qizil = warning && sanoq > 0;
	const toneHex = tone ? DASHBOARD_RANGLARI[tone] : undefined;

	const prefiks =
		icon && toneHex ? (
			<span
				data-stat-tone={tone}
				style={{ color: toneHex, backgroundColor: badgeFoni(toneHex) }}
				className="mr-1.5 inline-flex size-6 items-center justify-center rounded-md text-[13px]"
			>
				{icon}
			</span>
		) : (
			icon
		);

	return (
		<Card hoverable={clickable} styles={{ body: { minHeight: 108 } }}>
			<Statistic
				title={title}
				value={sanoq}
				loading={loading}
				prefix={prefiks}
				styles={qizil ? { content: { color: XAVF_RANGI } } : undefined}
			/>
			{hint ? (
				<Text type="secondary" className="mt-1 block text-xs">
					{hint}
				</Text>
			) : null}
		</Card>
	);
}
